import React from 'react';
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

type SortDropdownProps = {
  options: { label: string; value: string }[];
  value?: string;
  onChange?: (value: string) => void;
};

const SortDropdown: React.FC<SortDropdownProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <Listbox value={value} onChange={onChange}>
      <div className="relative">
        <ListboxButton className="p-2 w-[160px] rounded-sm h-8 focus:outline-none text-sm border border-gray-300 bg-white flex justify-between items-center">
          <span className="text-xs">
            {options.find((option) => option.value === value)?.label ||
              'Select an option'}
          </span>
          <ChevronDownIcon className="h-5 w-5 text-gray-500 ml-2" />
        </ListboxButton>
        <ListboxOptions className="absolute mt-8 w-[160px] bg-dropDownBg shadow-lg max-h-60 rounded-b-sm rounded-t-none py-1 text-xs ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none z-10">
          {options.map((option) => (
            <ListboxOption
              key={option.value}
              value={option.value}
              className={({ active }) =>
                `cursor-default select-none relative py-2 pl-4 pr-4 ${
                  active ? 'text-white bg-primary' : 'text-secondary'
                }`
              }
            >
              {({ selected }) => (
                <span
                  className={`block truncate ${
                    selected ? 'font-semibold' : 'font-normal'
                  }`}
                >
                  {option.label}
                </span>
              )}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
};

export default SortDropdown;
